module.exports = __webpack_public_path__ + "media/images/icons/plane-09aaa05ce14d69a0524aa48a338dc92c.svg";